import React from 'react';
import { ConfirmationTypes, deleteWorkshift } from '@pharmaplan/common';
import { useAppDispatch } from '../useAppDispatch';
import { resetDialog, setDialog } from '../../reducers/dialogReducer';
import ConfirmationModal from '../../components/Modals/ConfirmationModal';
import ContractDeleteMessage from '../../components/SelfService/WorkshiftSummary/WorkshiftSummaryList/SummaryContent/ContractDeleteMessage';

const useLongTermPharmacyActions = () => {
  const dispatch = useAppDispatch();

  const handleDelete = (workshiftId:string) =>
    () => {
      dispatch(
        deleteWorkshift({
          id: workshiftId,
          recurrenceId: '',
        }),
      );

      dispatch(resetDialog());
    };

  const confirmMultipleDelete = (workshiftId:string, count?:number) => {
    dispatch(
      setDialog({
        heading: {
          title: '',
        },
        Component: (
          <ConfirmationModal
            type={ConfirmationTypes.deleteMultipleContracts}
            customMessage={(
              <ContractDeleteMessage
                totalShiftCount={count ?? 0}
              />
            )}
            confirmAction={handleDelete(workshiftId)}
          />
        ),
        showCloseButton: false,
      }),
    );
  };

  const confirmSingleDelete = (workshiftId:string) => {
    dispatch(
      setDialog({
        heading: {
          title: '',
        },
        Component: (
          <ConfirmationModal
            type={ConfirmationTypes.deleteWorkshift}
            confirmAction={handleDelete(workshiftId)}
          />
        ),
        showCloseButton: false,
      }),
    );
  };

  const deleteShift = (isLongTerm:boolean, workshiftId:string, count?:number) => {
    if (isLongTerm) {
      confirmMultipleDelete(workshiftId, count);
      return;
    }

    confirmSingleDelete(workshiftId);
  };

  return { deleteShift };
};

export default useLongTermPharmacyActions;
